import { PropsWithChildren } from 'react';
import { AbleCommonProps } from '../Types';
import { SheetModalWrapper } from './context';

export type MultiSheetProps = {
    currentLevel: number;
    maxLevel: number;
    open: boolean;
    onClose?: (v?: any) => void;
} & PropsWithChildren & AbleCommonProps;

const MultiSheet = (props: MultiSheetProps) => {
    const { children, ...rest } = props;
    return (
        <SheetModalWrapper {...rest}>
            {children}
        </SheetModalWrapper>
    )
}

export default MultiSheet;